webpackJsonp([33],{

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04b8d3c.png";

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      loading: true,
      cupom: ''
    };
  },

  computed: {
    logoProviderCupom: function logoProviderCupom() {
      return this.$store.getters.logoProviderCupom;
    }
  },
  methods: {
    // goCheckIn () {
    //   if (this.cupom.length < 5) {
    //     this.$store.commit('toastr', {
    //       color: 'warning',
    //       texto: 'cupom invalido'
    //     })
    //   } else {
    //     this.$router.push('/a/Servicos/' + this.cupom)//  + this.cupom
    //   }
    // }
  },
  mounted: function mounted() {
    this.$store.commit('resetLogo');
    // var data = {
    //   token: this.token,
    //   type: this.type
    // },
    // this.$store.dispatch('getAllInfoCupom', data)
    //     .then((response) => {
    //       this.loading = false
    //     })
    //     .catch((err) => console.log(err))
  }
});

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".call-cupom{color:#464444;padding:10px;font-size:22px}.cupom{border:1px dashed gray;border-radius:5px;margin:20px}.cupom input{font-size:22px;width:100%;text-align:center;padding:0 15px;color:#464444;text-transform:uppercase}.texto{color:#42964d!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/Cupom.vue"],"names":[],"mappings":"AACA,YACE,cAAe,AACf,aAAc,AACd,cAAgB,CACjB,AACD,OACE,uBAAwB,AACxB,kBAAmB,AACnB,WAAa,CACd,AACD,aACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,eAAkB,AAClB,cAAe,AACf,wBAA0B,CAC3B,AACD,OACC,uBAA0B,CAC1B","file":"Cupom.vue","sourcesContent":["\n.call-cupom {\n  color: #464444;\n  padding: 10px;\n  font-size: 22px;\n}\n.cupom{\n  border: 1px dashed gray;\n  border-radius: 5px;\n  margin: 20px;\n}\n.cupom input{\n  font-size: 22px;\n  width: 100%;\n  text-align: center;\n  padding: 0px 15px;\n  color: #464444;\n  text-transform: uppercase;\n}\n.texto{\n\tcolor: #42964d !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(630);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("7bb25351", content, true, {});

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProviderFeedback === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "src": __webpack_require__(404),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProviderFeedback,
    attrs: {
      "src": _vm.logoProviderFeedback,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center call-cupom"
  }, [_c('strong', [_vm._v("Os condôminos do seu condomínio estão sendo comunicados, via email, neste exato momento.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center call-cupom texto"
  }, [_vm._v("\n      Muito obrigado!\n    ")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/33.c897f759bfcbb59046b2.js